module.exports = __webpack_public_path__ + "media/images/logo-color-40bb1255736711cbdfbeb30f6273f10e.png";